
export default {
  props: {
    name: {
      type: String,
      default: 'slideInUp',
    },
  },
  data() {
    return {}
  },
  computed: {
    className() {
      return `animate__${this.name}`
    },
  },
  mounted() {
    this.$animate.init()
    this.scroll()
  },
  methods: {
    scroll() {
      const top =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
        // 兼容性检测：判断浏览器是否支持 scrollTo 的对象参数
        const supportsSmoothScroll = 'scrollBehavior' in document.documentElement.style
        if (supportsSmoothScroll) {
          try {
            window.scrollTo({
              top: top + 1,
              behavior: 'smooth',
            })
          } catch (error) {
            window.scrollTo(0, top + 1)
          }
        } else {
          window.scrollTo(0, top + 1)
        }
    },
  },
}
